import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { organismLog } from 'utils/logUtil'
import { useSetChoice } from 'hooks/useCommon'
import { menu } from 'types/ReferTypes'
import { useUserAdd } from 'hooks/useUserTorokuTable'

const drawerWidth = 190

const useStyles = makeStyles(() =>
  createStyles({
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
      backgroundColor: '#F3FFD8',
    },
    drawerContainer: {
      overflow: 'auto',
    },
  }),
)

type Props = {
  menus: menu[]
  openMenu: boolean
}

const O_SideMenu = ({ menus, openMenu }: Props) => {
  useEffect(() => organismLog('O_SideMenu'))
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const [isJapell, setChoice] = useSetChoice(history, location)
  const openUserAdd = useUserAdd()

  if (!openMenu) return <></>
  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Toolbar />
      <div className={classes.drawerContainer}>
        <List dense>
          {menus.map((menu, index) => {
            const selected = menu.path === location.pathname
            if (isJapell && menu.path === '/changePassword') {
              // ジャペルのときはパスワード変更をメニューに表示しない
              return null
            }
            if (!isJapell && menu.path === '/userToroku') {
              // 得意先のときはユーザー登録を押すとユーザー追加モーダルを表示
              return (
                <ListItem key={index} button onClick={openUserAdd}>
                  <ListItemText primary={menu.label} />
                </ListItem>
              )
            }
            if (menu.path === '/manual') {
              // マニュアル表示は別タブへリンクさせる
              const path = `https://${window.location.hostname}/manual/${isJapell ? process.env.REACT_APP_MANUAL_JAPELL : process.env.REACT_APP_MANUAL_TOKUI}`
              return (
                <ListItem key={index}>
                  <a href={path} target="_blank">
                    {menu.label}
                  </a>
                </ListItem>
              )
            }
            return (
              <ListItem key={index} button selected={selected} onClick={() => setChoice(selected, menu.path)}>
                <ListItemText primary={menu.label} />
              </ListItem>
            )
          })}
        </List>
      </div>
    </Drawer>
  )
}
export default React.memo(O_SideMenu)
